import { Transportation } from '../_classes/list/transportation';

export let Transportations: Transportation[] = [
  {
    id: 1,
    client_id: 11,
    client: '',
    car_id: 3,
    car: 'а412ао74',
    punkt_id: 1,
    punkt: 'Органы государственной власти и органы местного самоуправления',
    reason_id: 1,
    category_id: 1,
    a_street_id: 23,
    a_street: 'г. Челябинск, Комсомольский пр-кт',
    a_dom: 2,
    a_korp: null,
    a_pod: null,
    a_adr: 'г. Челябинск, Победы, пр-кт, 2',
    a_dt: Date.parse('12.31.2017 12:00'),
    b_street_id: 89,
    b_street: 'г. Челябинск, Комсомольский пр-кт',
    b_dom: 78,
    b_korp: null,
    b_pod: null,
    b_adr: 'г. Челябинск, Комсомольский, пр-кт, 78',
    b_dt: Date.parse('01.01.2000 13:00'),
    convoy: false,
    comment: null,
    status_id: 1,
    status: 'Заявлено',
    user_id: 11,
    user: 'А.А. Чехов',
    dt: Date.parse('12.31.2017 13:00'),
    userm_id: 11,
    userm: 'А.А. Чехов',
    dtm: null,
    firm: 'КЦСОН Ленинского района г. Челябинска'
  },
  {
    id: 1,
    client_id: 11,
    client: '',
    car_id: 4,
    car: 'у435ка174',
    punkt_id: 1,
    punkt: 'Органы государственной власти и органы местного самоуправления',
    reason_id: 1,
    category_id: 1,
    a_street_id: 23,
    a_street: 'г. Челябинск, Победы пр-кт',
    a_dom: 2,
    a_korp: null,
    a_pod: null,
    a_adr: 'г. Челябинск, Победы, пр-кт, 2',
    a_dt: Date.parse('14.31.2017 10:00'),
    b_street_id: 89,
    b_street: 'г. Челябинск, Комсомольский пр-кт',
    b_dom: 78,
    b_korp: null,
    b_pod: null,
    b_adr: 'г. Челябинск, Комсомольский, пр-кт, 78',
    b_dt: Date.parse('01.01.2000 11:00'),
    convoy: false,
    comment: null,
    status_id: 1,
    status: 'Заявлено',
    user_id: 11,
    user: 'А.А. Сехов',
    dt: Date.parse('13.31.2017 13:00'),
    userm_id: 11,
    userm: 'А.А. Сехов',
    dtm: null,
    firm: 'КЦСОН Ленинского района г. Челябинска'
  }
]



// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/app/_mock/transportations.ts